import { ShieldCheck } from "lucide-react";
import { t } from "@/i18n";

export function SuspensionPolicy() {
  const points = ["p1", "p2", "p3", "p4", "p5"];
  return (
    <div data-testid="suspension-policy">
      <div className="mb-3 flex items-center gap-2">
        <ShieldCheck className="h-5 w-5 text-teal-700" />
        <h2 className="text-lg font-bold text-slate-900">{t("suspension.policyTitle")}</h2>
      </div>
      <ul className="list-disc space-y-2 pl-5 text-sm text-slate-700">
        {points.map((p) => <li key={p}>{t(`suspension.${p}`)}</li>)}
      </ul>
    </div>
  );
}
